<template lang="html">

  <section class="modulos-comunicaciones" v-if="comunicaciones.length > 0">

    <h2 class="titulo">{{$t('comunicaciones.titulo')}}</h2>

    <div class="comunicaciones-list row-between" >
      
      <comunicacion-el v-for="(n,key) in comunicaciones" :data="n" :key="key"></comunicacion-el>
      
    </div>


  </section>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  import comunicacionEl from './comunicacion-el'

  export default  {
    name: 'modulo-comunicaciones',
    components :{
      'comunicacion-el' : comunicacionEl
    },
    computed : {
      ...mapGetters({
        comunicaciones : 'getComunicaciones'
      }),
    }
  }
</script>

<style scoped lang="scss">
.titulo{
  width: 100%;
  padding: 0 20px;
  height: 55px;
  line-height: 55px;
  color: #fff;
  text-align: left;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
}

.comunicaciones-list{
  padding: 20px;
  max-height: 300px;
  overflow: scroll;
  overflow-x: hidden;
  position: relative;
}


.not-comunicaciones{
  text-align: left;
  font-size: 12px;
}

@media screen and (max-width: 550px){
  .comunicaciones-list{
    padding: 10px
  }
}

</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-comunicaciones.vue